import { produce } from 'immer';

import { COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE } from '../actions/companyClaimRestrictions.actions';

const initialState = {
  data: [],
};

const companyClaimRestrictionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE.GET_RESTRICTIONS:
      case COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE.UPDATE_RESTRICTIONS:
        draft.data = payload || [];
        break;

      default:
        return state;
    }
  });

export default companyClaimRestrictionsReducer;
